var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "new_top" },
        [_c("header2"), _vm._v(" "), _c("navigation", { ref: "navigation" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sy_main" }, [
        _c(
          "div",
          { staticClass: "sy_position" },
          [
            _vm._v("您当前的位置："),
            _c("router-link", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" >> 继续教育")
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sym_content2" }, [
          _c(
            "div",
            { staticClass: "symc2" },
            [
              _c("newsSimpleList", { attrs: { settings: _vm.tzggSettings } }),
              _vm._v(" "),
              _c("newsSimpleList", { attrs: { settings: _vm.zcfgSettings } }),
              _vm._v(" "),
              _c("newsSimpleList", { attrs: { settings: _vm.gzdtSettings } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "symc_right" },
            [_c("login"), _vm._v(" "), _c("latestNewsSimple")],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", {})
      ]),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57674015", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57674015","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ContinuingMedicalEducation.vue
// module id = null
// module chunks = 